<template>
  <v-container class="pa-0" fluid style="height: inherit; background-color: white;">
    <DraggableDividedLayout v-model="OtherTemplatesWidth" :hideCol1="!ShowOtherTemplates" :minValue="18" :maxValue="45">
      <template v-slot:col1>
        <v-toolbar dense flat fixed class="minitoolbar" ref="container">
          <OtherTemplatesListButton />
          <v-spacer />
        </v-toolbar>

        <v-progress-linear v-if="loading" indeterminate height="2" class="mb-0">
        </v-progress-linear>

        <v-list :style="'max-height: ' + containerHeight + '; overflow-y: auto;'" dense class="py-0">
          <v-subheader>Customer notification emails</v-subheader>
          <v-list-item v-for="ct in customerTemplates" :key="ct.key" link
            :to="{ name: 'EditEmailSetting', params: { emailTemplate: ct.key } }">
            <v-list-item-content>
              <v-list-item-title>{{ ct.title }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action class="my-0">
              <span :class="ct.enabled ? 'primary--text' : 'grey--text'" :style="ct.enabled ? '' : 'opacity: 0.7;'">
                {{ ct.enabled ? 'On' : 'Off' }}
              </span>
            </v-list-item-action>
          </v-list-item>

          <v-subheader class="mt-2">Other emails</v-subheader>
          <v-list-item v-for="at in agentTemplates" :key="at.key" link
            :to="{ name: 'EditEmailSetting', params: { emailTemplate: at.key } }">
            <v-list-item-content>
              <v-list-item-title>{{ at.title }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action class="my-0">
              <span :class="at.enabled ? 'primary--text' : 'grey--text'" :style="at.enabled ? '' : 'opacity: 0.7;'">
                {{ at.enabled ? 'On' : 'Off' }}
              </span>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </template>

      <template v-slot:col2>
        <router-view :showOtherTemplatesButton="true" />
      </template>
    </DraggableDividedLayout>
  </v-container>
</template>


<script>
import DraggableDividedLayout from '@/views/planning/DraggableDividedLayout.vue';
import EmailTemplatesMixin from '@/views/admin/settings/email/EmailTemplatesMixin.js';
import OtherTemplatesListButton from './OtherTemplatesListButton.vue';

export default {
  name: 'EmailTemplatesWrapper',
  components: {
    DraggableDividedLayout,
    OtherTemplatesListButton,
  },
  mixins: [EmailTemplatesMixin],

  data() {
    return {
      loading: false,
    };
  },

  async mounted() {
    try {
      this.loading = true;
      await this.fetchTemplates();
    } finally {
      this.loading = false;
    }
  },

  methods: {},

  computed: {
    containerHeight() {
      var contentHeight = this.$store.getters['navstore/ContentContainerHeight'];
      var res = 'calc(' + contentHeight + 'px - 48px)';
      //console.log('containerHeight', res)
      return res;
    },

    ShowOtherTemplates() {
      return this.$store.getters["prefrences/Prefrence"]("ShowOtherTemplates");
    },

    OtherTemplatesWidth: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("OtherTemplatesWidth");
      },
      set(update) {
        this.$store.dispatch("prefrences/set_prefrence", { key: "OtherTemplatesWidth", value: update });
      },
    },
  },

  watch: {},
};
</script>


<style lang="scss" scoped></style>